import { useGTM } from "../hooks/useGTM";

/**
 * Component that tracks page views via GTM.
 * Must be placed inside a Router component.
 * Renders nothing - only handles side effects.
 */
export const GTMPageTracker: React.FC = () => {
  // useGTM hook automatically tracks page views on route changes
  useGTM();
  return null;
};
